export default "__VITE_ASSET__676fc7c0__"